import { render, staticRenderFns } from "./LikeInfo.vue?vue&type=template&id=2550737a"
import script from "./LikeInfo.vue?vue&type=script&lang=js"
export * from "./LikeInfo.vue?vue&type=script&lang=js"
import style0 from "./LikeInfo.vue?vue&type=style&index=0&id=2550737a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports